package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("listApaleoProperties")
    val listApaleoProperties: List<ListApaleoProperty?>?,
    @SerialName("__typename")
    val typename: String?
)